class Drawer extends HTMLElement {
  constructor() {
    super();
    this.setAttribute('role', 'dialog');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const drawerId = this.getAttribute('data-drawer-id');
    const triggers = document.querySelectorAll(`[data-drawer-trigger="${drawerId}"]`);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const overlay = this.querySelector('[data-drawer-overlay]');

    if (triggers) {
      [...triggers].forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.open(trigger);
          }
        });
      });
    } else {
      console.error('Drawer triggers not found');
      return;
    }

    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add('animate', 'active');
    this.setAttribute('aria-hidden', 'false');
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.drawer__inner');
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.setAttribute('aria-hidden', 'true');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
